import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "../../utils/axiosinstance";
import { useAuthStore } from "../../../../user/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export interface StatusInfo {
    order_status: number;
    order_status_text: string;
    cancel_reason_idx: number;
    cancel_reason: string;
}

export interface ProductImage {
    file_idx: number;
    file_name: string;
    original_name: string;
}

export interface OrderFileProps {
    file_idx: number;
    file_name: string;
    original_name: string;
}

export interface RecipientInfo {
    wreath_sender: string;
    wreath_word: string;
    recipient_name: string;
    recipient_mobile: string;
    is_union: true;
    event_content: {
        event_content_idx: number;
        event_content: string;
        depth1_idx: number;
        depth1: string;
        depth2: string;
    };
    related_person: string;
    work_location: string;
    department: string;
    company_tel: string;
    delivery_immediate: true;
    delivery_date: string;
    delivery_time: string;
    delivery_post: string;
    delivery_address: string;
    delivery_address_detail: string;
    delivery_memo_idx: number;
    delivery_memo: string;
    order_file: OrderFileProps[];
    file_memo: string;
    order_memo: string;
}

export interface Category {
    product_category_idx: number;
    category_name: string;
}

export interface ProductInfo {
    product_idx: number;
    product_image: ProductImage;
    product_category: string;
    product_name: string;
    product_amount: number;
    product_quantity: number;
    sales_amount: number;
    delivered_image: OrderFileProps[];
    ready_image: OrderFileProps[];
}

export interface MemberInfo {
    customer_idx: number;
    customer_name: string;
    order_mobile: string;
    order_name: string;
}

export interface OrderData {
    order_idx: number;
    order_number: string;
    order_date: string;
    order_date_full: string;
    accept_date: string;
    delivery_complete_date: string;
    ready_date: string;
    cancel_date: string;
    status_info: StatusInfo;
    product_info: ProductInfo;
    recipient_info: RecipientInfo;
    member_info: MemberInfo;
}

export interface GetOrderResponse {
    statusCode: number;
    message: string;
    data: OrderData;
}

export const useGetOrderInfo = (orderId: number): UseQueryResult<OrderData, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);
    const url = enum_api_uri.user.get_order_info.replace(":order_idx", orderId.toString());
    const headers = {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };
    return useQuery<OrderData, Error>({
        queryKey: ["getOrderInfo", orderId],
        queryFn: async () => {
            const response = await axios.get(url, accessToken ? { ...headers } : {});
            return response.data.data;
        },
        enabled: !!orderId,
        placeholderData: prevData => {
            if (prevData) {
                return prevData;
            }
            return undefined;
        },
    });
};
